import { Directive, ElementRef, inject } from '@angular/core';

@Directive({
  selector: 'input[noSpaces]',
  host: {
    '(input)': 'onChange()',
  },
})
export class NoSpacesDirective {
  private elementRef = inject(ElementRef<HTMLInputElement>);

  onChange() {
    this.elementRef.nativeElement.value = this.elementRef.nativeElement.value.replace(/ /g, '');
  }
}
